import { render, staticRenderFns } from "./header-policy.vue?vue&type=template&id=b5a638be&scoped=true&"
var script = {}
import style0 from "./header-policy.vue?vue&type=style&index=0&id=b5a638be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a638be",
  null
  
)

export default component.exports